<template>
  <section>
    <ul class="breadcrumb list-inline">
      <li>
        <a class="breadcrumb-crumb cursor" @click="goTo('Home')">Inicio</a>
      </li>
      <li>
        <span class="breadcrumb-divider">&gt;</span>
        <a class="breadcrumb-crumb cursor" @click="goTo('Products')"
          >Productos</a
        >
      </li>
      <li>
        <span class="breadcrumb-divider">&gt;</span>
        <a
          class="breadcrumb-crumb cursor"
          @click="goTo(`Products?c=${prod.category}`)"
          >{{ prod.category }}</a
        >
      </li>
      <li>
        <span class="breadcrumb-divider">&gt;</span>
        <span class="breadcrumb-crumb"
          ><strong>{{ prod.name }} (Cod: {{ prod.code }})</strong></span
        >
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: "ShowRouter",
  props: {
    prod: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  methods: {
    goTo(route) {
      this.$router.replace(route);
    },
  },
};
</script>

<style scoped>
.font-small,
.cart-summary,
.cart-summary-items,
.nav-head-top,
.pill-link,
.breadcrumb {
  font-size: 12px;
}
.breadcrumb {
  width: 100%;
  margin: 20px auto 0 auto;
  background: none;
  text-align: center;
}
.breadcrumb {
  padding: 8px 15px;
  margin-bottom: 15px;
  list-style: none;
  border-radius: 4px;
  justify-content: center;
  font-size: revert;
}
.breadcrumb-crumb {
  color: rgba(95, 106, 121, 0.8);
}
.cursor {
  cursor: pointer;
}
li {
  text-align: -webkit-match-parent;
}

@media only screen and (max-width: 600px) {
  .breadcrumb {
    font-size: xx-small;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ShowRouter.vue